import axios, { AxiosRequestConfig } from 'axios'

export type FireblocksAssetResponse = {
  id: string
  name?: string
  symbol?: string
  legacyId?: string
  displayName?: string
  displaySymbol?: string
  media?: { url: string; type: string }[]
  metadata?: { media?: { url: string; type: string }[] }
}

export const getFireblocksAssetBySymbol = async (
  { token, symbol }: { token: string; symbol: string },
  options: AxiosRequestConfig = {},
): Promise<FireblocksAssetResponse[]> => {
  const response = await axios.get<FireblocksAssetResponse[]>(
    `${process.env.REACT_APP_SERVER_URL}/crm/fireblocks/get-asset/${symbol}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  const data = response.data as unknown
  if (Array.isArray(data)) return data as FireblocksAssetResponse[]
  if (data && typeof data === 'object') return [data as FireblocksAssetResponse]
  return []
}
